// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f6827e33","771":"187197a6"}[chunkId] + ".chunk.js";
};